import React from 'react';
import { styled } from 'styled-components';
import THEME from '../theme.js';
const Textarea = (props) => {
    return (React.createElement(InpContainer, { style: props.containerStyle },
        React.createElement("label", null,
            React.createElement(TextareaStyled, { onChange: props.onChange, autoFocus: props.autoFocus, onKeyDown: props.onKeyDown, className: props.className, 
                // type={props.type}
                value: props.value, style: {
                    padding: props.placeholder ? '' : '20px 15px',
                    ...props.style,
                }, ref: props.inputRef, onFocus: props.onFocus, onBlur: props.onBlur, disabled: props.disabled }),
            React.createElement("span", { className: `inp-placeholder ${props.value ? 'active' : ''}` }, props.placeholder))));
};
const InpContainer = styled.div `
  position: relative;
  font-weight: 700;

  .inp-placeholder {
    position: absolute;
    top: 14px;
    left: 15px;
    opacity: 0.6;
    font-size: 0.8em;
    transition: all 0.2s;
  }

  .inp-placeholder.active {
    top: 7px;
    font-size: 0.5em;
  }
`;
const TextareaStyled = styled.textarea `
  outline: none;
  border-radius: 3px;
  background-color: ${THEME.COLOR_SECONDARY};
  padding: 15px 15px 5px 15px;
  font-size: 0.9em;
  margin-bottom: 20px;
  width: 100%;
  background-image: none;
  border: 1px solid #ccc;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  box-sizing: border-box;
  resize: vertical;

  &:disabled {
    color: #696969;
    background-color: #ddd;
  }

  &:focus ~ .inp-placeholder {
    top: 7px;
    font-size: 0.5em;
  }
`;
export default Textarea;
//# sourceMappingURL=Textarea.js.map